import React, { useEffect, useRef, memo } from 'react';
import { ChandelierAreaSeries } from './plugins/ChandelierAreaSeries';

/**
 * ChandelierOverlay Component
 * React wrapper for the custom ChandelierAreaSeries plugin.
 */
const ChandelierOverlay = ({ 
    chartInstance, 
    id, 
    data, 
    options = {},
    onSeriesCreated
}) => {
    const seriesRef = useRef(null);
    const pluginRef = useRef(null);

    // Manage Series Lifecycle
    useEffect(() => {
        console.log(`[DIAG] ChandelierOverlay mount id=${id} chartInstance=${!!chartInstance}`);
        if (!chartInstance) return;

        let series;
        try {
            const plugin = new ChandelierAreaSeries();
            pluginRef.current = plugin;
            series = chartInstance.addCustomSeries(plugin, {
                ...plugin.defaultOptions(),
                ...options
            });
            seriesRef.current = series;
            console.log(`[DIAG] ChandelierOverlay addCustomSeries ok id=${id} seriesType=${typeof series}`);
        } catch (err) {
            console.error(`[DIAG] ChandelierOverlay addCustomSeries FAILED id=${id}`, err);
            return;
        }

        if (onSeriesCreated) {
            onSeriesCreated(id, series);
        }

        return () => {
            if (chartInstance && series) {
                try {
                    chartInstance.removeSeries(series);
                } catch (e) {}
            }
            if (onSeriesCreated) {
                onSeriesCreated(id, null);
            }
            seriesRef.current = null;
            pluginRef.current = null;
        };
    }, [chartInstance, id]);

    // Manage Data
    useEffect(() => {
        if (!seriesRef.current || !data) return;
        console.log(`[DIAG] ChandelierOverlay setData id=${id} len=${data.length} sample=${JSON.stringify(data[0])}`);
        try {
            seriesRef.current.setData(data);
        } catch (err) {
            console.error(`[DIAG] ChandelierOverlay setData FAILED id=${id}`, err);
        }
    }, [data]);

    // Manage Options (Style Updates)
    // NOTE: do NOT call pluginRef.current.update(data, opts) here — that overwrites
    // _data in the renderer with a raw array instead of the {bars, visibleRange}
    // structure that lw-charts provides via paneView.update(). applyOptions() is
    // sufficient; the chart engine will call paneView.update() with the correct shape.
    useEffect(() => {
        if (!seriesRef.current || !options) return;
        try {
            seriesRef.current.applyOptions(options);
        } catch (err) {
            console.warn(`[DIAG] ChandelierOverlay applyOptions error id=${id}`, err);
        }
    }, [options]);

    return null;
};

export default memo(ChandelierOverlay);
